import { IonContent, IonHeader, IonPage, IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonList, IonItem, IonLabel, IonGrid, IonRow, IonCol } from '@ionic/vue';
import AppToolbar from "@/components/app-structure/AppToolbar.vue";
import { defineComponent, computed } from 'vue';
import { useStore } from "vuex";
import useHash from "@/composables/hash";
import { openOutline as open } from 'ionicons/icons';
import LogoutButton from '@/components/list-items/LogoutButton.vue';
export default defineComponent({
    setup() {
        const store = useStore();
        const user = computed(() => store.state.user);
        const hash = useHash();
        return { user, hash, open };
    },
    components: {
        AppToolbar,
        IonContent,
        IonHeader,
        IonPage,
        IonCard,
        IonCardHeader,
        IonCardContent,
        IonCardTitle,
        IonList,
        IonItem,
        IonLabel,
        LogoutButton,
        IonGrid,
        IonRow,
        IonCol
    }
});
